module.exports = __webpack_public_path__ + "img/hummus-vegetale.868068ec.png";